import React from 'react';
import Lottie from 'react-lottie';
import './Reject_Lottie.css';
import * as animationData from './Reject_Lottie.json';

function Reject_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Reject_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}
export default Reject_Lottie;